import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from './CredentialsService'

const RoleRepository = RepositoryFactory.get('role')

class RoleService {
  static async getRoles (params) {
    try {
      return await RoleRepository.getRoles(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default RoleService
